import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useToast } from 'use-toast-mui';
import { getProgramCategory, getProgramSession, getPrograms } from '../../api/program';

import { errorMessages } from '../../utils/methods';
import BodyAskEditModal from './bodyCompound/bodyAskEditModal';
import BodyCategory from './bodyCompound/bodyCategory';
import BodyCreateModal from './bodyCompound/bodyCreateModal';
import BodySessionCreateModal from './bodyCompound/bodySessionCreateModal';
import QueryString from 'qs';

const BodySwitchTable = () => {
  const buttonStyle = {
    background: '#0F7F85',
    '&:hover': { backgroundColor: '#0F7F85' },
    borderRadius: '8px',
    height: '40px',
    width: '108px',
    fontSize: '13px',
    fontWeight: 600,
  };
  const boxStyle = {
    display: 'flex',
    flexDirection: 'column',
    height: '800px',
    width: '360px',
    bgcolor: 'white',
    borderRadius: '10px',
    padding: '20px 20px 20px 20px',
    justifyContent: 'space-between',
    mr: '30px',
  };

  const { t } = useTranslation();
  const toast = useToast();
  const { user } = useSelector(state => state.user);

  const [categories, setCategories] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [openCreate, setOpenCreate] = useState(false);
  const [openCreateSession, setOpenCreateSession] = useState(false);
  const [openAsk, setOpenAsk] = useState(false);
  const [typeBox, setTypeBox] = useState('');
  const [typeAsk, setTypeAsk] = useState('');
  const [selectedSession, setSelectedSession] = useState(null);
  const [tableNameBox, setTableNameBox] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [programs, setPrograms] = useState(null);

  const getCategory = async () => {
    try {
      const data = await getProgramCategory(user.token);

      const transformedData = data.map(e => ({
        id: e.categoryId,
        name: e.categoryName,
      }));
      setCategories(transformedData);
      setSessions([]);
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const getProgram = async id => {
    try {
      const requestObject = QueryString.stringify({
        categoryId: id,
      });
      const data = await getPrograms(requestObject, user.token);

      const transformedData = data.map(e => ({
        catId: id,
        id: e.programId,
        name: e.programName,
      }));
      setPrograms(transformedData);
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const getSession = async id => {
    try {
      const data = await getProgramSession(id, user.token);

      const transformedData = data.map(e => ({
        name: e.sessionName,
        id: e.sessionId,
        proId: id,
      }));
      setSessions(transformedData || []);
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  useEffect(() => {
    getCategory();
  }, []);
  useEffect(() => {}, [selectedCategory]);
  useEffect(() => {}, [selectedProgram]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
      }}>
      <Box sx={boxStyle}>
        <Box>
          <Typography
            sx={{
              color: '#0F7F85',
              fontSize: '13px',
              marginBottom: '10px',
            }}>
            {t('Categories')}
          </Typography>
          <hr></hr>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '650px',
              overflow: 'auto',
            }}>
            {categories.map((item, index) => (
              <BodyCategory
                key={index}
                setTypeAsk={setTypeAsk}
                type="categories"
                setSelectedCategory={setSelectedCategory}
                setSelectedProgram={setSelectedProgram}
                categories={item}
                typeCategory="categories"
                dataFunction={getCategory}
                setOpenAsk={setOpenAsk}
                arrowFunction={getProgram}
                setTableNameBox={setTableNameBox}
                setSessions={setSessions}
              />
            ))}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'end',
            height: '100%',
            alignItems: 'end',
          }}>
          <Button
            sx={buttonStyle}
            onClick={() => {
              setOpenCreate(true);
              setTypeBox('create');
              setTableNameBox('categories');
            }}
            variant="contained">
            {t('Add')}
          </Button>
        </Box>
      </Box>
      {selectedCategory != null && (
        <Box sx={boxStyle}>
          <Box>
            <Typography
              sx={{
                color: '#0F7F85',
                fontSize: '13px',
                marginBottom: '10px',
              }}>
              {t('Programs')}
            </Typography>
            <hr></hr>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '650px',
                overflow: 'auto',
              }}>
              {programs?.map((item, index) => (
                <BodyCategory
                  key={index}
                  type="programs"
                  setSelectedCategory={setSelectedProgram}
                  typeCategory="programs"
                  setTypeAsk={setTypeAsk}
                  categories={item}
                  dataFunction={getProgram}
                  setOpenAsk={setOpenAsk}
                  setTableNameBox={setTableNameBox}
                  arrowFunction={getSession}
                />
              ))}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'end',
              height: '100%',
              alignItems: 'end',
            }}>
            <Button
              sx={buttonStyle}
              onClick={() => {
                setOpenCreate(true);
                setTableNameBox('programs');
                setTypeBox('create');
              }}
              variant="contained">
              {t('Add')}
            </Button>
          </Box>
        </Box>
      )}
      {selectedProgram != null && (
        <Box sx={boxStyle}>
          <Box>
            <Typography
              sx={{
                color: '#0F7F85',
                fontSize: '13px',
                marginBottom: '10px',
              }}>
              {t('Sessions')}
            </Typography>
            <hr></hr>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '650px',
                overflow: 'auto',
              }}>
              {sessions?.map((item, index) => (
                <BodyCategory
                  key={index}
                  setSelectedCategory={setSelectedSession}
                  setOpenCreateSession={setOpenCreateSession}
                  categories={item}
                  typeCategory="sessions"
                  type="session"
                  setTableNameBox={setTypeBox}
                  setTypeAsk={setTypeAsk}
                  dataFunction={getSession}
                  setOpenAsk={setOpenAsk}
                />
              ))}
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'end',
              alignItems: 'end',
            }}>
            <Button
              sx={buttonStyle}
              onClick={() => {
                setOpenCreateSession(true);
                setTableNameBox('sessions');
                setTypeBox('create');
                setSelectedSession(null);
              }}
              variant="contained">
              {t('Add')}
            </Button>
          </Box>
        </Box>
      )}
      {openCreateSession === true ? (
        <BodySessionCreateModal
          open={openCreateSession}
          setOpen={setOpenCreateSession}
          data={selectedProgram}
          selectedSession={selectedSession}
          type={typeBox}
          getSession={getSession}
        />
      ) : (
        ''
      )}

      <BodyAskEditModal
        typeAsk={typeAsk}
        type={tableNameBox}
        open={openAsk}
        setTypeBox={setTypeBox}
        setOpen={setOpenAsk}
        setOpenCreate={setOpenCreate}
        setOpenCreateSession={setOpenCreateSession}
      />
      {openCreate === true ? (
        <BodyCreateModal
          data={tableNameBox === 'categories' ? selectedCategory : selectedProgram}
          getList={getCategory}
          getProgram={getProgram}
          type={typeBox}
          open={openCreate}
          setOpen={setOpenCreate}
          tableName={tableNameBox}
        />
      ) : (
        ''
      )}
    </Box>
  );
};

export default BodySwitchTable;
